import { MusicIcon } from '../icons/MusicIcon';
import { motion } from 'framer-motion';
import { Users, Trophy } from 'lucide-react';
import { useSocketStore } from '../../stores/socketStore';
import { useAuthStore } from '../../stores/authStore';

export default function TeamScoreDisplay() {
  const { teams, teamScores, modeConfig, currentRoom } = useSocketStore();
  const { player } = useAuthStore();
  
  if (!modeConfig?.teamBased || teams.length === 0) return null;
  
  // Trouver mon équipe
  const myTeamId = (currentRoom?.players.find(p => p.id === player?.id) as any)?.teamId;
  
  // Trier les équipes par score
  const sortedTeams = [...teams].sort((a, b) => {
    const scoreA = teamScores[a.id] || a.score || 0;
    const scoreB = teamScores[b.id] || b.score || 0;
    return scoreB - scoreA;
  });
  
  return (
    <div className="mb-4">
      <h3 className="text-sm font-semibold text-dark-400 mb-2 flex items-center gap-2">
        <Users className="w-4 h-4" />
        Scores des équipes
      </h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {sortedTeams.map((team, index) => {
          const score = teamScores[team.id] || team.score || 0;
          const isMyTeam = team.id === myTeamId;
          
          return (
            <motion.div
              key={team.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className={`p-3 rounded-lg ${
                isMyTeam 
                  ? 'bg-primary-500/20 border-2 border-primary-500' 
                  : 'bg-white/5 border border-white/10'
              }`}
              style={{ borderLeftColor: team.color, borderLeftWidth: '4px' }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  {index === 0 && <Trophy className="w-4 h-4 text-yellow-500" />}
                  <span className="font-semibold" style={{ color: team.color }}>
                    <MusicIcon name="players"/> {team.name}
                  </span>
                </div>
                <motion.span 
                  className="font-bold text-lg"
                  key={score}
                  initial={{ scale: 1.3 }}
                  animate={{ scale: 1 }}
                >
                  {score}
                </motion.span>
              </div>
              
              {/* Joueurs de l'équipe */}
              <div className="mt-1 text-xs text-dark-400">
                {team.players.length} joueur{team.players.length > 1 ? 's' : ''}
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
